import { render, staticRenderFns } from "./ProductPropertyInput.vue?vue&type=template&id=a591495c&"
import script from "./ProductPropertyInput.vue?vue&type=script&lang=ts&"
export * from "./ProductPropertyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports